// L'acquisizione è sequenziale. Una nuova matricola non può essere scambiata
// per il barcode prodotto della coppia precedente: la coppia incompleta resta
// un tentativo con errore e la nuova prenotazione riapre il contesto.
export function pianificaSparo({ pending, current, doppioControllo, matricola }) {
  if (!doppioControllo) return { lettura:current, prodotto:null, pending:null };
  if (matricola) return { lettura:pending, prodotto:null, pending:current };
  if (pending) return { lettura:pending, prodotto:current.barcode, pending:null };
  return { lettura:current, prodotto:null, pending:null };
}
